import React, { useState, useEffect } from 'react';

import { supabase } from '../lib/supabaseClient';
export default function MobilePopup() {
   console.log('MobilePopup rendering');
  const [show, setShow] = useState(false);
  const [phone, setPhone] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');


useEffect(() => {
  const seen = localStorage.getItem('popup_seen');
  console.log('popup_seen value:', seen);
  if (!seen) {
    console.log('Setting timer...');
    const timer = setTimeout(() => {
      console.log('Showing popup now');
      setShow(true);
    }, 3000);
    return () => clearTimeout(timer);
  }
}, []);


 const handleSubmit = async () => {
  if (!/^\d{10}$/.test(phone)) {
    setError('Please enter a valid 10-digit mobile number');
    return;
  }

  const { data: existing } = await supabase
    .from('leads')
    .select('id')
    .eq('mobile', phone)
    .maybeSingle();

  if (existing) {
    localStorage.setItem('popup_seen', 'true');
    setSuccess(true);
    setTimeout(() => setShow(false), 2500);
    return;
  }

  const { error } = await supabase
    .from('leads')
    .insert({ mobile: phone, source: 'popup' });

  if (!error) {
    localStorage.setItem('popup_seen', 'true');
    setSuccess(true);
    setTimeout(() => setShow(false), 2500);
  }
};

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: '#fff', borderRadius: '16px', width: '320px',
        overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        {/* Header */}
        <div style={{ background: '#1a0a00', padding: '1.5rem', textAlign: 'center' }}>
          <p style={{ color: '#faecea', fontSize: '22px', fontWeight: '600', margin: '0 0 4px' }}>
            Get 10% off
          </p>
          <p style={{ color: '#b89a88', fontSize: '13px', margin: 0 }}>
            your first order at Urban Thek
          </p>
        </div>

        {/* Body */}
        <div style={{ padding: '1.25rem 1.5rem 1.5rem' }}>
          {!success ? (
            <>
              <p style={{ fontSize: '13px', color: '#666', marginBottom: '12px' }}>
                Enter your mobile number to claim your welcome discount
              </p>
              <input
                type="tel"
                placeholder="98765 43210"
                maxLength={10}
                value={phone}
                onChange={e => {
                  setPhone(e.target.value.replace(/\D/g, ''));
                  setError('');
                }}
                style={{
                  width: '100%', boxSizing: 'border-box', padding: '10px 12px',
                  fontSize: '15px', border: '1px solid #ddd', borderRadius: '8px',
                  marginBottom: '8px'
                }}
              />
              {error && <p style={{ color: 'red', fontSize: '12px', margin: '0 0 8px' }}>{error}</p>}
              <button
                onClick={handleSubmit}
                style={{
                  width: '100%', padding: '12px', background: '#d85a30',
                  color: '#fff', border: 'none', borderRadius: '8px',
                  fontSize: '15px', fontWeight: '600', cursor: 'pointer'
                }}
              >
                Claim my discount
              </button>
              <p
                onClick={() => {
                  localStorage.setItem('popup_seen', 'true');
                  setShow(false);
                }}
                style={{
                  textAlign: 'center', fontSize: '12px', color: '#999',
                  marginTop: '10px', cursor: 'pointer', textDecoration: 'underline'
                }}
              >
                No thanks, I'll pay full price
              </p>
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: '1rem 0' }}>
              <p style={{ fontSize: '32px', margin: '0 0 8px' }}>🎉</p>
              <p style={{ fontSize: '18px', fontWeight: '600', margin: '0 0 6px' }}>You're in!</p>
              <p style={{ fontSize: '13px', color: '#666', margin: 0 }}>
                Your 10% discount has been applied.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}